import React, { useEffect, useState } from 'react';
import CollectionProducts from './CollectionProducts.jsx';
import Axios from 'axios';
import PictureBlock from './PictureBlock.jsx';
import getHtmlAttributes from '../utils/getHtmlAttributes.js';

export default function RelatedCollection(props) {
  const [products, setProducts] = useState(false);
  const block = {...props.block};
  const aspect = block.image.width / block.image.height;
  const htmlAttributes = getHtmlAttributes(block.shopify_attributes);
  block.mobile_image = {...block.image};
  if (aspect > 2/3) {
    block.mobile_image.width = block.image.height * 3/2;
  } else {
    block.mobile_image.height = block.image.width * 2/3;
  }
  block.mobile_image.crop = block.alignment === 'right' ? 'left' : block.alignment === 'left' ? 'right' : 'center';
  useEffect(() => {
    if (!products) {
      Axios.get(`/collections/${props.block.collection}?view=_json_related_collection`).then(response => {
        const limit = props.block.products_per_row * props.block.rows;
        setProducts(response.data.products.slice(0, limit));
      })
    }
  }, [props])

  if (!products) {
    return null;
  }
  
  return (
    <div className="related-collection content-area" {...htmlAttributes}>
      <PictureBlock {...block} width="fullwidth" className="related-collection-header" />
      <div className={props.className}>
        <CollectionProducts products={products} collectionHandle={props.block.collection} blocks={[]} />
      </div>
    </div>
  )
}